module.exports = __webpack_public_path__ + "img/gongshui4.1bf423b2.png";